import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - NuPitch</title>
        <meta name="description" content="Terms of Service for NuPitch Incentive Match Maker" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <div className="container-responsive py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg border border-gray-200 p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
            
            <div className="prose prose-gray max-w-none">
              <p className="text-sm text-gray-600 mb-6">
                <strong>Last updated:</strong> January 27, 2025
              </p>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-700 mb-4">
                  By accessing and using NuPitch Incentive Match Maker ("Service"), you accept and agree to be bound by the terms and provision of this agreement.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Description of Service</h2>
                <p className="text-gray-700 mb-4">
                  NuPitch provides a platform for matching film and television projects with global tax incentives and rebates. Our service analyzes project descriptions and scripts to suggest relevant incentive programs.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>BETA Notice:</strong> This is a beta service. All estimates and matches are indicative only and should be verified directly with the relevant incentive commissions.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Use License</h2>
                <p className="text-gray-700 mb-4">
                  Permission is granted to temporarily use NuPitch for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                </p>
                <ul className="list-disc pl-6 text-gray-700 mb-4">
                  <li>modify or copy the materials</li>
                  <li>use the materials for any commercial purpose or for any public display</li>
                  <li>attempt to reverse engineer any software contained on the website</li>
                  <li>remove any copyright or other proprietary notations from the materials</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">4. User Content</h2>
                <p className="text-gray-700 mb-4">
                  By uploading scripts or submitting project descriptions, you grant NuPitch a limited license to process and analyze your content for the purpose of providing incentive matching services.
                </p>
                <p className="text-gray-700 mb-4">
                  We retain only sanitized excerpts of your content for processing purposes. Full scripts are automatically deleted within 48 hours of submission.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Disclaimer</h2>
                <p className="text-gray-700 mb-4">
                  The information on this website is provided on an 'as is' basis. To the fullest extent permitted by law, NuPitch excludes all representations, warranties, conditions and terms whether express or implied, statutory or otherwise.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>Important:</strong> All incentive estimates are indicative only. Actual incentive amounts, eligibility criteria, and application processes may differ. Always confirm details directly with the relevant incentive commission.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Limitations</h2>
                <p className="text-gray-700 mb-4">
                  In no event shall NuPitch or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on NuPitch's website.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Accuracy of Materials</h2>
                <p className="text-gray-700 mb-4">
                  The materials appearing on NuPitch's website could include technical, typographical, or photographic errors. NuPitch does not warrant that any of the materials on its website are accurate, complete, or current.
                </p>
                <p className="text-gray-700 mb-4">
                  Our incentive database is based on the Global Incentives Index 2025 (World of Locations / Olsberg•SPI), with data correct to April 11, 2025. Incentive programs may change without notice.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Links</h2>
                <p className="text-gray-700 mb-4">
                  NuPitch has not reviewed all of the sites linked to our website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by NuPitch of the site.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Modifications</h2>
                <p className="text-gray-700 mb-4">
                  NuPitch may revise these terms of service at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Governing Law</h2>
                <p className="text-gray-700 mb-4">
                  These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which NuPitch operates.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Contact Information</h2>
                <p className="text-gray-700 mb-4">
                  If you have any questions about these Terms of Service, please contact us at:
                </p>
                <p className="text-gray-700">
                  Email: <a href="mailto:info@nupitchtechnologies.com?subject=NuPitch Incentive Match Maker Terms of Service" className="text-primary-600 hover:underline">info@nupitchtechnologies.com</a><br />
                  Website: <a href="/contact" className="text-primary-600 hover:text-primary-800">Contact Form</a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;